import React, { useState, useEffect, memo, useRef } from 'react';
import { Formik, Form, FieldArray } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import { navigate } from 'gatsby';
import { enableGATracking } from 'gatsby-env-variables';
import Header from '../../common/components/Header/Header';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../data/SiteConfig';
import {
  professionTypeOptions,
  propertyTypeOptions,
  IndustryTypeOptionsSEP,
  TypeOfRentalIncomeOptions,
  typeOfTwoWheelerLoan,
  typeOfBusinessLoan,
  propertyTypeOptionsForLAP
} from './PersonalDiscussionOptions';
import CommonPincode from '../../components/Dashboard-res/CommonComponent/CommonPincode';
import CommonInput from '../../components/Dashboard-res/CommonComponent/CommonInput';
import CommonSelect from '../../components/Dashboard-res/CommonComponent/CommonSelect';
import InputTypeNumber from '../../common/components/InputTypeNumber/InputTypeNumber';
import InputTypeFloat from '../../common/components/InputTypeDecimalNumber/InputTypeFloat';
import RadioButton from '../../components/Dashboard-res/CommonComponent/RadioButton';
import {
  getPropertyDetailsApi,
  getIndustryTypeProfessionDetail,
  GetKhataList,
  savePDInfoAPI,
  actionOnLeadInPD,
  getPD
} from '../../common/constants/api';
import _, { stubFalse } from 'lodash';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import PopUp from '../../common/components/PopUp/PopUp';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CommonBtn from '../LeadProfile/CommonBtn/CommonBtn';
import get from 'lodash/get';
import styles from './PersonalDiscussionForm.module.css';
import PDBasicInfo from './PDBasicInfo';
import backBtn_icon from '../../images/icons/backBtn_icon.svg';
import plusBp from '../../images/icons/plusBp.svg';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  getApplicantionInfo,
  setApplicantionInfo
} from '../../common/utils/applicantionInfo';
import Toast from '../../common/components/Toast/Toast';
import MaleImage from '../../images/icons/male.svg';
import Female from '../../images/icons/UserKycIcons/female_icon.svg';
import common_gender from '../../images/icons/UserKycIcons/common_gender.svg';
import CommonDatePicker from '../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import ChangeLeadStatus from './PD/ChangeStatusOfLead';
import MakeACall from '../../components/MakeACall/MakeACall';
const whatsApp_icon = '/images/icons/whatsApp/WhatsApp.svg';
import PhoneIcon from '@material-ui/icons/Phone';
import MessageUi from '../../components/MessageSystem/MessageUi';
import { baseUrl } from 'gatsby-env-variables';
import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from '@material-ui/core/styles';
import ResizeObserver from '../../common/components/ResizeObserver/ResizeObserver';
import NoteSection from './PD/NoteSection';
import Audit from '../../containers/Audit/Audit';

const validationSchema = Yup.object().shape({
  productType: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  BTAmount: Yup.string()
    .when(['productTypeId', 'productType'], {
      is: (productTypeId, productType) =>
        productTypeId == '13' &&
        (productType.value == 19 || productType.value == 20),
      then: Yup.string()
        .required('Required')
        .test('BTAmount', 'Amount should be in between 10K and 50L', function(
          val
        ) {
          if (val != undefined) {
            let checkAmount = parseInt(val.replace(/,/g, ''));
            if (checkAmount >= 10000 && checkAmount <= 5000000) return true;
            else return false;
          }
        })

        .min(5, 'Should be more than 10K')
        .max(7, 'should be lesser than 50L')
    })
    .when('productType', {
      is: productType => {
        return (
          productType.value == 10 ||
          productType.value == 11 ||
          productType.value == 16 ||
          productType.value == 17
        );
      },
      then: Yup.string()
        .required('Required')
        .test(
          'BTAmount',
          'Amount should be in between 10 Lakh and 99 Cr',
          function(val) {
            if (val != undefined) {
              let checkAmount = parseInt(val.replace(/,/g, ''));
              if (checkAmount >= 1000000 && checkAmount <= 990000000)
                return true;
              else return false;
            }
          }
        )
    }),

  BTInterest: Yup.string().when('productType', {
    is: productType => {
      return (
        productType.value == 10 ||
        productType.value == 11 ||
        productType.value == 16 ||
        productType.value == 17 ||
        productType.value == 19 ||
        productType.value == 20
      );
    },
    then: Yup.string().required('Required')
  }),
  BTBankName: Yup.string().when('productType', {
    is: productType => {
      return (
        productType.value == 10 ||
        productType.value == 11 ||
        productType.value == 16 ||
        productType.value == 17 ||
        productType.value == 19 ||
        productType.value == 20
      );
    },
    then: Yup.string().required('Required')
  }),

  professionType: Yup.object().shape({
    value: Yup.string().required('Required')
  }),

  employerNameSalaried: Yup.string().when('professionType', {
    is: professionType => {
      return professionType.value == 'SALARIED';
    },
    then: Yup.string().required('Required')
  }),
  experienceYearSalaried: Yup.string().when('professionType', {
    is: professionType => {
      return professionType.value == 'SALARIED';
    },
    then: Yup.string().required('Required')
  }),

  industyTypeForSepOrSenp: Yup.object().when('professionType', {
    is: professionType =>
      professionType.value === 'SELF_EMPLOYED' ||
      professionType.value === 'SELF_EMPLOYED_PROFESSIONAL',
    then: Yup.object().shape({
      value: Yup.string().required('Required')
    })
  }),

  yearsInbusinessForSepOrSenp: Yup.string().when('professionType', {
    is: professionType =>
      professionType.value === 'SELF_EMPLOYED' ||
      professionType.value === 'SELF_EMPLOYED_PROFESSIONAL',
    then: Yup.string().required('Required')
  }),
  ITRFiled: Yup.string().when('productTypeId', {
    is: val => val != '13',
    then: Yup.string().required('Required')
  }),

  monthlyIncome: Yup.string().required('Required'),
  rentalAgreement: Yup.string().required('Required'),

  rentalIncome: Yup.string().when('rentalAgreement', {
    is: 'true',
    then: Yup.string().required('Required')
  }),
  TypeOfRentalIncome: Yup.object().when('rentalAgreement', {
    is: 'true',
    then: Yup.object().shape({
      value: Yup.string().required('Required')
    })
  }),

  percentageOfCheque: Yup.string().when(
    ['TypeOfRentalIncome', 'rentalAgreement'],
    {
      is: (TypeOfRentalIncome, rentalAgreement) => {
        return (
          TypeOfRentalIncome.value == 'Cash And Cheque' &&
          rentalAgreement === 'true'
        );
      },
      then: Yup.string()
        .required('Required')
        .test(
          'percentageOfCheque',
          'Percentage should not be more than 100%',
          function(val) {
            if (val != undefined) {
              let percentageOfCheque = parseInt(val.replace(/,/g, ''));
              if (percentageOfCheque <= 100) return true;
              else return false;
            }
          }
        )
    }
  ),

  propertyType: Yup.object().when(
    ['productTypeId', 'propertyIdentified', 'property'],
    {
      is: (val, propertyIdentified, property) =>
        (val != '13' &&
          val != '12' &&
          val != '2' &&
          propertyIdentified == 'true') ||
        (val == '2' && property == 'residential'),
      then: Yup.object().shape({
        value: Yup.string().required('Required')
      })
    }
  ),
  propertyTitle: Yup.object().when(['productTypeId', 'propertyIdentified'], {
    is: (val, propertyIdentified) =>
      val != '13' && val != '12' && propertyIdentified == 'true',
    then: Yup.object().shape({
      value: Yup.string().required('Required')
    })
  }),
  pincode: Yup.string()
    .nullable()
    .when(['productTypeId', 'propertyIdentified'], {
      is: (val, propertyIdentified) =>
        val != '13' && val != '12' && propertyIdentified == 'true',
      then: Yup.string()
        .required('Required')
        .max(6, 'Pincode should be 6 digit numbers')
        .matches(/\d{6}/, 'Pincode should be digits only')
    }),
  propertyValue: Yup.string().when(['productTypeId', 'propertyIdentified'], {
    is: (val, propertyIdentified) =>
      val != '13' && val != '12' && propertyIdentified == 'true',
    then: Yup.string().required('Required')
  }),

  allCoApplicant: Yup.array().of(
    Yup.object().shape({
      coApplicantProfessiontype: Yup.object().shape({
        value: Yup.string().required('Required')
      }),
      coApplicantMonthlyIncome: Yup.string().required('Required')
    })
  ),
  noOfUnit: Yup.string()
    .nullable()
    .when(['productTypeId', 'propertyType'], {
      is: (productTypeId, propertyType) =>
        productTypeId == '1' && propertyType?.value == 'Independent House',
      then: Yup.string().required('Required')
    }),
  gender: Yup.string().required('Required')
});

let commonInputTypeNumberStyle = {
  height: '30px',
  paddingLeft: '40px',
  paddingTop: '10px',
  letterSpacing: '1px'
};
const PersonalDiscussionForm = () => {
  const { DetailContainer, coAppicantContainer, eachContainer } = styles;

  return (
    <Formik
      initialValues={{
        productType: { value: '', label: 'Product Type' },
        BTAmount: '',
        BTInterest: '',
        BTBankName: '',
        professionType: { value: '', label: 'Profession type' },
        employerNameSalaried: '',
        experienceYearSalaried: '',
        industyTypeForSepOrSenp: { value: '', label: 'Select Industry Type' },
        yearsInbusinessForSepOrSenp: '',
        ITRFiled: '',
        monthlyIncome: '',
        rentalAgreement: '',
        rentalIncome: '',
        TypeOfRentalIncome: { value: '', label: 'Type of Rental Income' },
        percentageOfCheque: '',
        propertyType: { value: '', label: 'Property Type' },
        propertyTitle: { value: '', label: 'Property Title' },
        pincode: '',
        pincodeCity: '',
        pincodeState: '',
        propertyValue: '',
        allCoApplicant: [],
        productTypeId: new URLSearchParams(window.location.search)?.get(
          'loanType'
        ),
        date: {
          value: '',
          label: 'Date'
        },
        month: {
          value: '',
          label: 'Month'
        },
        year: {
          value: moment().format('YYYY') - 18,
          label: moment().format('YYYY') - 18
        },
        property: 'commercial',
        propertyIdentified: 'true',
        gender: ''
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        isSubmitting
      }) => {
        const [productTypeOptions, setProductTypeOptions] = useState([]);
        const [industryTypeOptions, setIndustryTypeOptions] = useState([]);

        const [khata, setKhata] = useState([]);
        const [commentData, setCommentData] = useState([]);
        const [userDataForWA, setUSerDataForWA] = useState({});
        const [showWhatsApp, setShowWhatsApp] = useState(false);
        const pdSectionRef = useRef('');
        const [noteViewType, setNotesViewType] = useState('');
        const [showNotes, setShowNotes] = useState(false);
        const [showAuditTrail, setShowAuditTrail] = useState(false);

        const [type, setType] = useState('loading');
        const [text, setText] = useState('Loading...');
        const [show, setShow] = useState(false);
        const [pdData, setPDData] = useState([]);
        useEffect(() => {
          setTimeout(() => {
            if (noteViewType && showNotes) setNotesViewType(true);
            else if (!noteViewType && showNotes) setNotesViewType(undefined);
            if (!showNotes) setNotesViewType('False');
          }, 50);
        }, [showNotes]);
        const [leadStatus, setLeadStatus] = useState(
          getApplicantionInfo()?.leadData?.status || ''
        );
        const useStyles = makeStyles({
          drawerBottomRoot: {
            ['@media (max-width:767px)']: {
              width: '100%',
              height: '85vh',
              zIndex: '900 !important'
            },
            ['@media (min-width:768px)']: {
              display: 'none'
            }
          },
          drawerRightRoot: {
            ['@media (min-width:768px)']: {
              width: '100%',
              height: '100vh'
            },
            ['@media (max-width:767px)']: {
              display: 'none'
            }
          },
          drawerBottomPaper: {
            ['@media (max-width:767px)']: {
              width: '100%',
              marginTop: '9vh',
              height: '90vh'
            },
            ['@media (min-width:768px)']: {
              display: 'none'
            }
          },
          drawerRightPaaper: {
            ['@media (min-width:768px)']: {
              width: '350px',
              height: '100vh'
            },
            ['@media (max-width:767px)']: {
              display: 'none'
            }
          },
          paperAnchorBottom: {
            borderTopRightRadius: '20px',
            borderTopLeftRadius: '20px',
            maxHeight: '80vh'
          },
          root: {
            ['@media (max-width:768px)']: {
              width: '100%',
              marginTop: '9vh',
              height: '91vh'
            },
            ['@media (min-width:769px)']: {
              width: '500px'
            }
          }
        });
        const classes = useStyles();

        const [applicationInfo, setApplicatiionInfo] = useState(
          getApplicantionInfo() || {}
        );
        const [showChangeStatusModel, setShowChangeStatusModel] = useState(
          false
        );

        function IndustryTypeOptions(profession) {
          if (profession === 'SELF_EMPLOYED_PROFESSIONAL') {
            return IndustryTypeOptionsSEP;
          } else if (profession === 'SELF_EMPLOYED') {
            return industryTypeOptionFun();
          }
        }
        function addNewComment(passText) {
          const addNewData = [...commentData];

          let userDataStringified = localStorage.getItem('userData');
          let userInfo = null;
          if (userDataStringified) {
            userInfo = JSON.parse(userDataStringified);
          }

          addNewData.push({
            name:
              userInfo?.name?.firstName + ' ' + userInfo?.name?.lastName || '',
            createdAt: moment().format(),

            comment: passText
          });
          setCommentData(addNewData);
        }
        function khataListFun() {
          if (khata.length !== 0) {
            return khata.map(each => {
              return {
                label: each?.propertyTitle,
                value: each?.id
              };
            });
          } else {
            return [
              {
                label: 'No Khata Available',
                value: 'No Khata Available'
              }
            ];
          }
        }

        const getTheProductTypes = productId => {
          getPropertyDetailsApi(productId)
            .then(res => {
              if (res.length > 0) {
                setProductTypeOptions(res);
              } else if (productId == '12') {
                setProductTypeOptions(typeOfBusinessLoan);
              } else if (productId == '14') {
                setProductTypeOptions(typeOfTwoWheelerLoan);
              } else {
                setProductTypeOptions([]);
              }
            })
            .catch(err => {
              setShow(false);
            });
        };

        useEffect(() => {
          if (values?.productTypeId) {
            getTheProductTypes(values?.productTypeId);
          } else {
            getTheProductTypes(1);
          }
        }, []);

        function productTypeOptionsFun() {
          return productTypeOptions.map(each => {
            return {
              label: each?.displayName,
              value: each?.id
            };
          });
        }

        useEffect(() => {
          getIndustryTypeProfessionDetail()
            .then(res => {
              setIndustryTypeOptions(res);
            })
            .catch(err => {
              setShow(false);
            });
        }, []);

        function industryTypeOptionFun() {
          return industryTypeOptions.map(each => {
            return {
              label: each?.name,
              value: each?.id
            };
          });
        }

        useEffect(() => {
          setFieldValue('propertyTitle', {
            value: '',
            label: ' Property Title'
          });
          setKhata([]);
        }, [values?.pincode]);

        const getKhataList = () => {
          if (values?.pincode?.length == 6) {
            GetKhataList(values?.pincode)
              .then(res => {
                setKhata(res);
              })
              .catch(err => {
                setShow(false);
              });
          }
        };
        const creatBody = () => {
          return {
            propertyIdentified:
              values?.propertyIdentified == 'true' ? true : false,
            personalDetails: {
              gender: values?.gender,
              ...(values.year?.value &&
              values.month?.value &&
              values.date?.value
                ? {
                    dateOfBirth: `${values.year?.value}-${_.padStart(
                      values.month?.value,
                      2,
                      0
                    )}-${_.padStart(values.date?.value, 2, 0)}`
                  }
                : {})
            },
            productDetail: {
              productId: values?.productType?.value,
              displayName: values?.productType?.label
            },

            btDetails: {
              btAmount: parseInt(values?.BTAmount || 0),
              btInterest: parseInt(values?.BTInterest || 0),
              btBankName: values?.BTBankName || ''
            },
            incomeDetails: {
              professionType: values?.professionType?.value,

              selfEmployedProfession:
                values?.professionType?.value ===
                  'SELF_EMPLOYED_PROFESSIONAL' && values?.professionType?.value
                  ? values?.industyTypeForSepOrSenp?.label
                  : '',

              industryTypeDetail: {
                ...(values?.professionType?.value === 'SELF_EMPLOYED'
                  ? {
                      industrySectionId: values?.industyTypeForSepOrSenp?.value,
                      name: values?.industyTypeForSepOrSenp?.label
                    }
                  : { name: '' })
              },
              employerName: values?.employerNameSalaried || '',
              experienceInYears:
                parseInt(values?.experienceYearSalaried) ||
                parseInt(values?.yearsInbusinessForSepOrSenp),
              itrFiled: values?.ITRFiled === 'true',
              monthlyIncome: parseInt(values?.monthlyIncome),
              anyRentalIncome: values?.rentalAgreement === 'true',
              amountOfRentalIncome: parseInt(values?.rentalIncome || ''),
              typeOfRentalIncome: values?.TypeOfRentalIncome?.value || '',
              percentageOfCheque: parseInt(values?.percentageOfCheque || ''),
              totalMonthlyObligations: values.currObligation
            },
            ...(values.productTypeId != '13' &&
            values.productTypeId != '12' &&
            values.propertyIdentified == 'true'
              ? {
                  leadPDPropertyDetails: {
                    propertyType:
                      values.productTypeId != '2'
                        ? values?.propertyType?.value
                        : values?.property == 'commercial'
                        ? 'Commercial Property'
                        : values?.propertyType?.value,

                    pincode: values?.pincode,
                    propertyValue: values?.propertyValue,
                    propertyTitleDetail: {
                      ...(values.propertyTitle.value &&
                      values.propertyTitle.value !== 'No Khata Available'
                        ? {
                            propertyTitleId: values?.propertyTitle?.value,
                            name: values?.propertyTitle?.label
                          }
                        : { name: '' })
                    },
                    buildingUnits: values?.noOfUnit || null
                  }
                }
              : {}),
            listOfApplicantDetails:
              (values?.allCoApplicant?.length > 0 &&
                values?.allCoApplicant?.map(each => {
                  return {
                    professionType: each?.coApplicantProfessiontype?.value,
                    monthlyIncome: each?.coApplicantMonthlyIncome
                  };
                })) ||
              [],

            listOfComments:
              (commentData.length > 0 &&
                commentData.map(each => {
                  return {
                    name: each?.name,
                    comment: each?.comment,
                    createdAt: each?.createdAt
                  };
                })) ||
              []
          };
        };
        useEffect(() => {
          let leadData = getApplicantionInfo()?.leadData;
          const data = {
            applicationStatus: leadData?.status || '',
            leadId: leadData?.leadId,
            leadApplicantId: leadData?.leadMainApplicantId,
            applicantInfo: {
              id: leadData?.leadMainApplicantId,
              mainApplicant: 'Main Applicant',
              phoneNumber: leadData?.phoneNumber
            },
            leadData: {
              loanAmount: leadData?.loanAmount || '---',
              loanProduct: leadData?.loanProduct || '---'
            }
          };
          setUSerDataForWA(data);
        }, []);
        function savePDForm() {
          setType('loading');
          setText('Saving The Details Please Wait...');
          setShow(true);
          savePDInfoAPI(creatBody(), getApplicantionInfo().leadId)
            .then(res => {
              setShow(false);
              Toast(
                'success',
                'PD details saved successfully',
                '3000',
                'top-center'
              );
            })
            .catch(error => {
              setShow(false);
            });
        }

        useEffect(() => {
          setType('loading');
          setText('Getting The Details Please Wait...');
          setShow(true);
          if (industryTypeOptions && productTypeOptions) {
            getPD(getApplicantionInfo().leadId)
              .then(res => {
                if (res.error) throw new Error(res);
                setShow(false);
                setPDData(res);
                preFillTheData(res);
              })
              .catch(error => {
                setShow(false);
              });
          }
        }, [productTypeOptions, industryTypeOptions]);

        const preFillTheData = data => {
          setFieldValue('productType', {
            label: data?.productDetail?.displayName || 'Product Type',
            value: data?.productDetail?.productId || ''
          });
          setFieldValue('BTAmount', data?.btDetails?.btAmount || '');
          setFieldValue('BTInterest', data?.btDetails?.btInterest || '');
          setFieldValue('BTBankName', data?.btDetails?.btBankName || '');

          setFieldValue(
            'employerNameSalaried',
            data?.incomeDetails?.employerName || ''
          );
          setFieldValue(
            'experienceYearSalaried',
            data?.incomeDetails?.experienceInYears || ''
          );
          setFieldValue(
            'yearsInbusinessForSepOrSenp',
            data?.incomeDetails?.experienceInYears || ''
          );
          if (
            data?.incomeDetails.professionType == 'SELF_EMPLOYED_PROFESSIONAL'
          ) {
            setFieldValue('industyTypeForSepOrSenp', {
              label: data?.incomeDetails?.selfEmployedProfession,
              value: data?.incomeDetails?.selfEmployedProfession
            });
          } else {
            setFieldValue('industyTypeForSepOrSenp', {
              label:
                data?.incomeDetails?.industryTypeDetail.name || 'Industry Type',
              value: data?.incomeDetails?.industryTypeDetail.industrySectionId
            });
          }
          setFieldValue(
            'ITRFiled',
            data?.incomeDetails?.itrFiled ? 'true' : 'false'
          );
          setFieldValue('monthlyIncome', data?.incomeDetails?.monthlyIncome);
          setFieldValue(
            'rentalAgreement',
            data?.incomeDetails?.anyRentalIncome ? 'true' : 'false'
          );

          setFieldValue(
            'rentalIncome',
            data?.incomeDetails?.amountOfRentalIncome || ''
          );
          setFieldValue(
            'percentageOfCheque',
            data?.incomeDetails?.percentageOfCheque || ''
          );
          setFieldValue('TypeOfRentalIncome', {
            label:
              data?.incomeDetails?.typeOfRentalIncome ||
              'Type of Rental Income',
            value: data?.incomeDetails?.typeOfRentalIncome || ''
          });

          setFieldValue('pincode', data?.leadPDPropertyDetails?.pincode);
          setFieldValue(
            'propertyValue',
            data?.leadPDPropertyDetails?.propertyValue || ''
          );
          setFieldValue('propertyTitle', {
            label:
              data?.leadPDPropertyDetails?.propertyTitleDetail?.name ||
              'Property Title',
            value:
              data?.leadPDPropertyDetails?.propertyTitleDetail?.propertyTitleId
          });
          let applicantData = [];
          data.listOfApplicantDetails?.map(element => {
            professionTypeOptions.map(each => {
              if (each.value == element?.professionType) {
                applicantData.push({
                  coApplicantProfessiontype: {
                    label: each.label,
                    value: each.value
                  },
                  coApplicantMonthlyIncome: element?.monthlyIncome
                });
              }
            });
          });
          let commits = [];
          data.listOfComments?.map(element => {
            commits.push({
              name: element?.name,
              comment: element?.comment,
              createdAt: element?.createdAt
            });
          });
          setCommentData(commits);

          //these are for
          professionTypeOptions.map(each => {
            if (each.value == data?.incomeDetails?.professionType) {
              setFieldValue('professionType', {
                value: each.value,
                label: each.label
              });
            }
          });
          setFieldValue('propertyType', {
            label: data?.leadPDPropertyDetails?.propertyType || 'Property Type',
            value: data?.leadPDPropertyDetails?.propertyType
          });
          if (
            propertyTypeOptionsForLAP.find((each, index) => {
              if (each.value == data?.leadPDPropertyDetails?.propertyType) {
                return setFieldValue('property', 'residential');
              } else if ((index = propertyTypeOptionsForLAP.length - 1)) {
                return setFieldValue('property', 'commercial');
              }
            })
          )
            setFieldValue('allCoApplicant', applicantData);
          setFieldValue(
            'currObligation',
            data?.incomeDetails?.totalMonthlyObligations || 0
          );
          setFieldValue('gender', data?.personalDetails?.gender);
          setFieldValue('year', {
            label: data?.personalDetails?.dateOfBirth
              ? moment(data?.personalDetails?.dateOfBirth).format('YYYY')
              : 'Year',
            value: data?.personalDetails?.dateOfBirth
              ? moment(data?.personalDetails?.dateOfBirth).format('YYYY')
              : ''
          });
          setFieldValue('month', {
            label: data?.personalDetails?.dateOfBirth
              ? moment(data?.personalDetails?.dateOfBirth).format('MMMM')
              : 'Month',
            value: data?.personalDetails?.dateOfBirth
              ? moment(data?.personalDetails?.dateOfBirth).format('M')
              : ''
          });
          setFieldValue('date', {
            label: data?.personalDetails?.dateOfBirth
              ? moment(data?.personalDetails?.dateOfBirth).format('DD')
              : 'Date',
            value: data?.personalDetails?.dateOfBirth
              ? moment(data?.personalDetails?.dateOfBirth).format('DD')
              : ''
          });
          setFieldValue(
            'propertyIdentified',
            data?.propertyIdentified || values?.productTypeId == '2'
              ? 'true'
              : 'false'
          );
          setFieldValue(
            'noOfUnit',
            data?.leadPDPropertyDetails?.buildingUnits || ''
          );
        };

        const handleRejection = () => {
          setType('loading');
          setText('Rejecting The Lead In PD!');
          setShow(true);
          actionOnLeadInPD(getApplicantionInfo().leadId, creatBody(), 'reject')
            .then(res => {
              if (res.error) throw new Error(res);
              setShow(false);
              navigate('/app/dashboard?type=leads');
            })
            .catch(error => {
              setShow(false);
            });
        };

        const handleAcception = () => {
          setType('loading');
          setText('Wait a while we are submitting your data...');
          setShow(true);
          actionOnLeadInPD(getApplicantionInfo().leadId, creatBody(), 'accept')
            .then(res => {
              let leadData = getApplicantionInfo();
              leadData['applicationStatus'] = 'New Lead';
              setApplicantionInfo(leadData);
              if (enableGATracking) {
                ga(
                  'send',
                  'event',
                  'Button',
                  'Click',
                  'Lead Created',
                  getApplicantionInfo().leadData?.loanAmount,
                  { loanAmount: getApplicantionInfo().leadData?.loanAmount }
                );
              }
              if (res.error) throw new Error(res);
              setShow(false);
              navigate('/app/leadprofile');
            })
            .catch(error => {
              setShow(false);
            });
        };

        useEffect(() => {
          if (values?.gender) {
            setFieldTouched('gender', true);
          }
        }, [values?.gender]);

        const GetNotesSection = ({ normalView }) => {
          const [textVal, setTextVal] = useState('');

          return (
            <NoteSection
              styles={styles}
              commentData={commentData}
              setShowChangeStatusModel={setShowChangeStatusModel}
              addNewComment={addNewComment}
              setTextVal={setTextVal}
              textVal={textVal}
              noteViewType={noteViewType}
              setShow={setShowNotes}
              setShowAuditTrail={setShowAuditTrail}
              normalView={normalView}
            />
          );
        };
        return (
          <React.Fragment>
            <Helmet title={`Dashboard RM | ${siteTitle}`} />

            <div className="bg-grey-950 relative h-full  font-roboto text-sm font-normal m-0 p-0">
              <div className=" min-h-screen flex pt-17 md:pt-0">
                <Sidebar />
                <div className="flex-1  w-full widhtMd max-screen">
                  <Header />
                  <Drawer
                    anchor="right"
                    open={showWhatsApp}
                    onClose={() => setShowWhatsApp(false)}
                    onOpen={() => setShowWhatsApp(true)}
                    classes={{ paper: classes.root }}
                  >
                    <div className={`w-full `}>
                      <MessageUi
                        baseUrl={baseUrl}
                        applicantInfo={userDataForWA?.applicantInfo}
                        setShowWhatsApp={setShowWhatsApp}
                        userData={userDataForWA}
                      />
                    </div>
                  </Drawer>

                  <div className="">
                    <Form
                      autoComplete="off"
                      onSubmit={handleSubmit}
                      className="h-full  mx-3"
                    >
                      <ResizeObserver
                        targetNodeRef={pdSectionRef}
                        handleCallBack={() => {
                          if (pdSectionRef?.current?.clientWidth < 1000) {
                            return setNotesViewType('drawer');
                          }
                          return setNotesViewType('');
                        }}
                      >
                        <div className={`w-full flex bg-navy-600 `}>
                          <div className="bg-white h-full   p-3 pb-8 text-black-600 font-roboto shadow-xs rounded pt-10 w-full">
                            <div
                              style={{ top: '-6px' }}
                              className="grid md:grid-cols-2 gap-y-3 md:gap-y-0 items-center relative w-full"
                            >
                              <div className="">
                                <ArrowBackIosIcon
                                  onClick={() =>
                                    navigate('/app/dashboard?type=leads')
                                  }
                                  className="text-black-400 border cursor-pointer  border-radius-full border-black-400 pl-2 rounded-full  py-1 text-center h-7 w-7"
                                />
                                <span className="pl-3 text-black-1015 text-base text-black-400 font-open-sans">
                                  Personal Discussion Form
                                </span>
                              </div>

                              <div className=" md:ml-auto flex float-right clear-both items-center">
                                <span>
                                  <MakeACall
                                    phoneNumber={
                                      applicationInfo?.leadData
                                        ?.leadApplicantPhone
                                    }
                                    leadId={applicationInfo?.leadData?.leadId}
                                    applicantId={
                                      applicationInfo?.leadData
                                        ?.leadMainApplicantId
                                    }
                                    PhoneNumberClasses="hidden"
                                    CustomIcon={PhoneIcon}
                                    phoneCallStyles={{
                                      color: '#0A4549',
                                      height: '18px'
                                    }}
                                    callWrapperStyle={{
                                      height: ' 30px',
                                      width: '32px',
                                      paddingTop: '6px'
                                    }}
                                    callWrapperClasses="bg-white rounded-full shadow px-1 py-1 box-shadow"
                                    loadingWrapperClasses="-mt-0.5"
                                  />
                                </span>
                                <span>
                                  <img
                                    src={whatsApp_icon}
                                    style={{ height: '39px' }}
                                    className="ml-2 mr-2 cursor-pointer"
                                    onClick={() => setShowWhatsApp(true)}
                                  />
                                </span>
                                <ChangeLeadStatus
                                  showModal={showChangeStatusModel}
                                  setShowModal={setShowChangeStatusModel}
                                  rowData={getApplicantionInfo()?.leadData}
                                  onUpdation={e =>
                                    setLeadStatus(e?.updateStatus?.value)
                                  }
                                />
                                <span>
                                  <button
                                    onClick={() =>
                                      setShowChangeStatusModel(true)
                                    }
                                    type="button"
                                    className="font-open-sans px-4 py-1 rounded border border-yellow-fuelYellow text-yellow-fuelYellow bg-white text-roboto font-normal "
                                  >
                                    Update Status
                                  </button>
                                </span>
                                {noteViewType && (
                                  <span>
                                    <button
                                      onClick={() => setShowNotes(true)}
                                      type="button"
                                      className="font-open-sans ml-2 px-4 py-1 rounded border border-yellow-fuelYellow text-yellow-fuelYellow bg-white text-roboto font-normal "
                                    >
                                      Notes
                                    </button>
                                  </span>
                                )}
                              </div>
                            </div>

                            <PDBasicInfo />
                            <div
                              className={`${!noteViewType &&
                                ''}`}
                            >
                              <div className="">
                                <div className="text-base my-3 font-open-sans-bold">
                                  Personal Details
                                </div>
                                <div className="w-full  flex flex-wrap">
                                  <div className=" mb-3">
                                    <p className="font-roboto font-normal text-grey-920 text-base">
                                      Gender
                                    </p>
                                    <div
                                      className={
                                        ' w-full flex  mr-10 -ml-3 -mt-3'
                                      }
                                      style={{ minWidth: '228px' }}
                                    >
                                      <div
                                        className={
                                          values.gender == 'Male'
                                            ? 'assignedImg'
                                            : 'assignImg'
                                        }
                                        onClick={() =>
                                          setFieldValue('gender', 'Male')
                                        }
                                      >
                                        <img
                                          className="cursor-pointer px-2 "
                                          style={{
                                            height: '50px',
                                            marginLeft: '10px',
                                            width: '67px'
                                          }}
                                          src={MaleImage}
                                        />
                                      </div>
                                      <div
                                        className={
                                          values.gender == 'Female'
                                            ? 'assignedImg'
                                            : 'assignImg'
                                        }
                                        onClick={() =>
                                          setFieldValue('gender', 'Female')
                                        }
                                      >
                                        <img
                                          className="cursor-pointer px-2"
                                          src={Female}
                                          style={{
                                            height: '50px',
                                            marginLeft: '10px',
                                            width: '67px'
                                          }}
                                        />
                                      </div>
                                      <div
                                        className={
                                          values.gender == 'Unspecified'
                                            ? 'assignedImg'
                                            : 'assignImg'
                                        }
                                        onClick={() =>
                                          setFieldValue('gender', 'Unspecified')
                                        }
                                      >
                                        <img
                                          className="cursor-pointer px-2"
                                          src={common_gender}
                                          style={{
                                            height: '50px',
                                            marginLeft: '8px',
                                            width: '67px'
                                          }}
                                        />
                                      </div>
                                    </div>
                                    {errors?.gender && touched?.gender ? (
                                      <p className="text-red-100 pt-2 ">
                                        Required
                                      </p>
                                    ) : null}
                                  </div>

                                  <div
                                    className="DOB_field lg:w-3/12 md:w-6/12 "
                                    style={{ minWidth: '300px' }}
                                  >
                                    <div className="grid_input_container mb-8">
                                      <p className="font-roboto font-normal text-grey-920 text-base mb-2">
                                        DOB
                                      </p>
                                      <CommonDatePicker
                                        datePickerContainerstyle={{
                                          height: '50px',
                                          gridTemplateColumns: '35% 30% 30%'
                                        }}
                                        onChangeMonth={(value, isValidDate) => {
                                          setFieldValue('month', value, true);
                                          setFieldTouched('month', true, false);
                                          if (!isValidDate) {
                                            setFieldValue(
                                              'date',
                                              {
                                                value: '',
                                                label: 'Date'
                                              },
                                              true
                                            );
                                          }
                                        }}
                                        onChangeYear={(value, isValidDate) => {
                                          setFieldValue('year', value, true);
                                          setFieldTouched('year', true, false);

                                          if (!isValidDate) {
                                            setFieldValue(
                                              'date',
                                              {
                                                value: '',
                                                label: 'Date'
                                              },
                                              true
                                            );
                                          }
                                        }}
                                        onChangeDate={value => {
                                          setFieldValue('date', value, true);
                                          setFieldTouched('date', true, false);
                                        }}
                                        valueMonth={values.month}
                                        valueYear={values.year}
                                        valueDate={values.date}
                                        errorYear={
                                          touched.year &&
                                          get(errors, 'year.value', false)
                                        }
                                        touchedYear={touched.year}
                                        onBlurYear={() => {
                                          setFieldTouched('year', true, true);
                                        }}
                                        errorMonth={
                                          touched.month &&
                                          get(errors, 'month.value', false)
                                        }
                                        touchedMonth={touched.month}
                                        onBlurMonth={() => {
                                          setFieldTouched('month', true, true);
                                        }}
                                        // errors.date.value
                                        errorDate={
                                          touched.date &&
                                          get(errors, 'date.value', false)
                                        }
                                        touchedDate={touched.date}
                                        onBlurDate={() => {
                                          setFieldTouched('date', true, true);
                                        }}
                                        type="dob"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="text-base my-3 font-open-sans-bold">
                                Loan Details
                              </div>
                              <div className={`${DetailContainer}`}>
                                <CommonSelect sort={true}
                                  name="productType"
                                  value={values.productType}
                                  onChange={e => {
                                    setFieldValue('productType', e);
                                  }}
                                  onBlur={() => {
                                    setFieldTouched('productType', true, true);
                                  }}
                                  options={productTypeOptionsFun()}
                                  dropdownStyle={{
                                    top: '52px',
                                    fontSize: '16px'
                                  }}
                                  stylesContainer={{
                                    height: '52px'
                                  }}
                                  styleText={{
                                    fontSize: '14px',
                                    padding: '0 20px'
                                  }}
                                  error={
                                    touched.productType &&
                                    get(errors, 'productType.value', false)
                                  }
                                  touched={touched.productType}
                                />
                                {[10, 11, 16, 17, 19, 20].includes(
                                  values.productType?.value
                                ) ? (
                                  <>
                                    <InputTypeNumber
                                      name="BTAmount"
                                      value={values.BTAmount}
                                      maxLength={15}
                                      minLength={0}
                                      legendName="BT Amount"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      stylesContainer={{
                                        maxWidth: '100%'
                                      }}
                                      inputStyle={commonInputTypeNumberStyle}
                                      iconStyle={{ marginTop: '12px' }}
                                      error={
                                        touched.BTAmount && errors.BTAmount
                                      }
                                      errorMsg={errors.BTAmount}
                                      touched={touched.BTAmount}
                                      setFieldValue={setFieldValue}
                                      showInText={false}
                                    />
                                    <InputTypeFloat
                                      name="BTInterest"
                                      value={values.BTInterest}
                                      maxLength={7}
                                      minLength={0}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      rupeeIcon={false}
                                      error={
                                        touched.BTInterest && errors.BTInterest
                                      }
                                      errorMsg={errors.BTInterest}
                                      touched={touched.BTInterest}
                                      setFieldValue={setFieldValue}
                                      stylesContainer={{
                                        maxWidth: '100%'
                                      }}
                                      inputStyle={{
                                        paddingLeft: '15px',
                                        letterSpacing: '1px'
                                      }}
                                      legendStyle={{ paddingLeft: '5px' }}
                                      legendName="BT Interest (%)"
                                    />
                                    <CommonInput
                                      name="BTBankName"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.BTBankName}
                                      stylesContainer={{
                                        maxWidth: '100%'
                                      }}
                                      legendName="BT Bank"
                                      error={
                                        touched.BTBankName && errors.BTBankName
                                      }
                                      errorMsg={errors.BTBankName}
                                      touched={touched.BTBankName}
                                    />
                                  </>
                                ) : null}
                              </div>

                              <div className="text-base my-3 font-open-sans-bold">
                                Income Details
                              </div>

                              <div className={`${DetailContainer}`}>
                                <CommonSelect sort={true}
                                  name="professionType"
                                  value={values.professionType}
                                  onChange={e => {
                                    setFieldValue('professionType', e);
                                  }}
                                  onBlur={() => {
                                    setFieldTouched(
                                      'professionType',
                                      true,
                                      true
                                    );
                                  }}
                                  options={professionTypeOptions}
                                  dropdownStyle={{
                                    top: '52px',
                                    fontSize: '16px'
                                  }}
                                  stylesContainer={{
                                    height: '52px'
                                  }}
                                  styleText={{
                                    fontSize: '14px',
                                    padding: '0 20px'
                                  }}
                                  error={
                                    touched.professionType &&
                                    get(errors, 'professionType.value', false)
                                  }
                                  touched={touched.professionType}
                                />

                                {values.professionType.value === 'SALARIED' && (
                                  <>
                                    <CommonInput
                                      name="employerNameSalaried"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.employerNameSalaried}
                                      stylesContainer={{
                                        maxWidth: '100%'
                                      }}
                                      legendName="Employer Name"
                                      error={
                                        touched.employerNameSalaried &&
                                        errors.employerNameSalaried
                                      }
                                      errorMsg={errors.employerNameSalaried}
                                      touched={touched.employerNameSalaried}
                                    />

                                    <InputTypeFloat
                                      name="experienceYearSalaried"
                                      value={values.experienceYearSalaried}
                                      maxLength={7}
                                      minLength={0}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      rupeeIcon={false}
                                      error={
                                        touched.experienceYearSalaried &&
                                        errors.experienceYearSalaried
                                      }
                                      errorMsg={errors.experienceYearSalaried}
                                      touched={touched.experienceYearSalaried}
                                      setFieldValue={setFieldValue}
                                      stylesContainer={{
                                        maxWidth: '100%'
                                      }}
                                      inputStyle={{
                                        paddingLeft: '15px',
                                        letterSpacing: '1px'
                                      }}
                                      legendStyle={{ paddingLeft: '5px' }}
                                      legendName="Experience (Years)"
                                    />
                                  </>
                                )}

                                {(values?.professionType?.value ===
                                  'SELF_EMPLOYED' ||
                                  values?.professionType?.value ===
                                    'SELF_EMPLOYED_PROFESSIONAL') && (
                                  <>
                                    <CommonSelect sort={true}
                                      name="industyTypeForSepOrSenp"
                                      value={values?.industyTypeForSepOrSenp}
                                      onChange={e => {
                                        setFieldValue(
                                          'industyTypeForSepOrSenp',
                                          e
                                        );
                                      }}
                                      onBlur={() => {
                                        setFieldTouched(
                                          'industyTypeForSepOrSenp',
                                          true,
                                          true
                                        );
                                      }}
                                      options={IndustryTypeOptions(
                                        values?.professionType?.value
                                      )}
                                      dropdownStyle={{
                                        top: '52px',
                                        fontSize: '16px'
                                      }}
                                      stylesContainer={{
                                        height: '52px'
                                      }}
                                      styleText={{
                                        fontSize: '14px',
                                        padding: '0 20px'
                                      }}
                                      error={
                                        touched.industyTypeForSepOrSenp &&
                                        get(
                                          errors,
                                          'industyTypeForSepOrSenp.value',
                                          false
                                        )
                                      }
                                      touched={touched.industyTypeForSepOrSenp}
                                    />

                                    <InputTypeFloat
                                      name="yearsInbusinessForSepOrSenp"
                                      value={values.yearsInbusinessForSepOrSenp}
                                      maxLength={7}
                                      minLength={0}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      rupeeIcon={false}
                                      error={
                                        touched.yearsInbusinessForSepOrSenp &&
                                        errors.yearsInbusinessForSepOrSenp
                                      }
                                      errorMsg={
                                        errors.yearsInbusinessForSepOrSenp
                                      }
                                      touched={
                                        touched.yearsInbusinessForSepOrSenp
                                      }
                                      setFieldValue={setFieldValue}
                                      stylesContainer={{
                                        maxWidth: '100%'
                                      }}
                                      inputStyle={{
                                        paddingLeft: '15px',
                                        letterSpacing: '1px'
                                      }}
                                      legendStyle={{ paddingLeft: '5px' }}
                                      legendName="No. of years in Business"
                                    />
                                  </>
                                )}
                                {values.productTypeId != '13' ? (
                                  <div className="flex flex-col justify-between">
                                    <div> ITR Filed?</div>
                                    <div className="flex">
                                      <div className="flex mr-4">
                                        <RadioButton
                                          name="ITRFiled"
                                          value="true"
                                          checked={values.ITRFiled === 'true'}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                        />
                                        <label htmlFor="true" className="mx-4">
                                          Yes
                                        </label>
                                      </div>

                                      <div className="flex">
                                        <RadioButton
                                          name="ITRFiled"
                                          value="false"
                                          checked={values.ITRFiled === 'false'}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                        />
                                        <label htmlFor="false" className="ml-4">
                                          No
                                        </label>
                                      </div>
                                    </div>

                                    {touched.ITRFiled && (
                                      <div className="text-red-100 text-left">
                                        {errors.ITRFiled}
                                      </div>
                                    )}
                                  </div>
                                ) : null}
                                <InputTypeNumber
                                  name="monthlyIncome"
                                  value={values.monthlyIncome}
                                  maxLength={15}
                                  minLength={0}
                                  legendName="Monthly Income"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  stylesContainer={{
                                    maxWidth: '100%'
                                  }}
                                  inputStyle={commonInputTypeNumberStyle}
                                  error={
                                    touched.monthlyIncome &&
                                    errors.monthlyIncome
                                  }
                                  errorMsg={errors.monthlyIncome}
                                  touched={touched.monthlyIncome}
                                  setFieldValue={setFieldValue}
                                  showInText={false}
                                  iconStyle={{ marginTop: '12px' }}
                                />

                                <div className="flex flex-col justify-between">
                                  <div> Any Rental Income?</div>
                                  <div className="flex">
                                    <div className="flex mr-4">
                                      <RadioButton
                                        name="rentalAgreement"
                                        value="true"
                                        checked={
                                          values.rentalAgreement === 'true'
                                        }
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      />
                                      <label htmlFor="true" className="mx-4">
                                        Yes
                                      </label>
                                    </div>

                                    <div className="flex">
                                      <RadioButton
                                        name="rentalAgreement"
                                        value="false"
                                        checked={
                                          values.rentalAgreement === 'false'
                                        }
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      />
                                      <label htmlFor="false" className="ml-4">
                                        No
                                      </label>
                                    </div>
                                  </div>

                                  {touched.rentalAgreement && (
                                    <div className="text-red-100 text-left">
                                      {errors.rentalAgreement}
                                    </div>
                                  )}
                                </div>

                                {values?.rentalAgreement === 'true' && (
                                  <>
                                    <InputTypeNumber
                                      name="rentalIncome"
                                      value={values.rentalIncome}
                                      maxLength={15}
                                      minLength={0}
                                      legendName="Amount of Rental Income"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      stylesContainer={{
                                        maxWidth: '100%'
                                      }}
                                      inputStyle={commonInputTypeNumberStyle}
                                      error={
                                        touched.rentalIncome &&
                                        errors.rentalIncome
                                      }
                                      errorMsg={errors.rentalIncome}
                                      touched={touched.rentalIncome}
                                      setFieldValue={setFieldValue}
                                      showInText={false}
                                      iconStyle={{ marginTop: '12px' }}
                                    />

                                    <CommonSelect sort={true}
                                      name="TypeOfRentalIncome"
                                      value={values.TypeOfRentalIncome}
                                      onChange={e => {
                                        setFieldValue('TypeOfRentalIncome', e);
                                      }}
                                      onBlur={() => {
                                        setFieldTouched(
                                          'TypeOfRentalIncome',
                                          true,
                                          true
                                        );
                                      }}
                                      options={TypeOfRentalIncomeOptions}
                                      dropdownStyle={{
                                        top: '52px',
                                        fontSize: '16px'
                                      }}
                                      stylesContainer={{
                                        height: '52px'
                                      }}
                                      styleText={{
                                        fontSize: '14px',
                                        padding: '0 20px'
                                      }}
                                      error={
                                        touched.TypeOfRentalIncome &&
                                        get(
                                          errors,
                                          'TypeOfRentalIncome.value',
                                          false
                                        )
                                      }
                                      touched={touched.TypeOfRentalIncome}
                                    />
                                  </>
                                )}

                                {values.TypeOfRentalIncome.value ===
                                  'Cash And Cheque' &&
                                  values.rentalAgreement === 'true' && (
                                    <InputTypeFloat
                                      name="percentageOfCheque"
                                      value={values.percentageOfCheque}
                                      maxLength={7}
                                      minLength={0}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      rupeeIcon={false}
                                      error={
                                        touched.percentageOfCheque &&
                                        errors.percentageOfCheque
                                      }
                                      errorMsg={errors.percentageOfCheque}
                                      touched={touched.percentageOfCheque}
                                      setFieldValue={setFieldValue}
                                      stylesContainer={{
                                        maxWidth: '100%'
                                      }}
                                      inputStyle={{
                                        paddingLeft: '15px',
                                        letterSpacing: '1px'
                                      }}
                                      legendStyle={{ paddingLeft: '5px' }}
                                      legendName="Percentage of cheque (%)"
                                    />
                                  )}
                              </div>

                              <div className="text-base my-3 font-open-sans-bold">
                                Current Obligation
                              </div>
                              <div className={`${DetailContainer} mb-4`}>
                                <InputTypeNumber
                                  name="currObligation"
                                  value={values.currObligation}
                                  maxLength={15}
                                  minLength={0}
                                  legendName="Total Monthly Obligations"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  stylesContainer={{
                                    maxWidth: '100%'
                                  }}
                                  inputStyle={commonInputTypeNumberStyle}
                                  iconStyle={{ marginTop: '12px' }}
                                  error={
                                    touched.currObligation &&
                                    errors.currObligation
                                  }
                                  errorMsg={errors.currObligation}
                                  touched={touched.currObligation}
                                  setFieldValue={setFieldValue}
                                  showInText={false}
                                />
                              </div>

                              {values?.productTypeId != '13' &&
                              values?.productTypeId != '12' ? (
                                <React.Fragment>
                                  <div className="text-base my-3 font-medium">
                                    Property Details
                                  </div>
                                  {values?.productTypeId != '2' ? (
                                    <div className="flex flex-col justify-between mb-4 mt-2 ml-1">
                                      <div> Property Identified</div>
                                      <div className="flex mt-2 ">
                                        <div className="flex mr-4">
                                          <RadioButton
                                            name="propertyIdentified"
                                            value="true"
                                            checked={
                                              values.propertyIdentified ===
                                              'true'
                                            }
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          />
                                          <label
                                            htmlFor="true"
                                            className="mx-4"
                                          >
                                            Yes
                                          </label>
                                        </div>

                                        <div className="flex">
                                          <RadioButton
                                            name="propertyIdentified"
                                            value="false"
                                            checked={
                                              values.propertyIdentified ===
                                              'false'
                                            }
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          />
                                          <label
                                            htmlFor="false"
                                            className="ml-4"
                                          >
                                            No
                                          </label>
                                        </div>
                                      </div>

                                      {touched.propertyIdentified && (
                                        <div className="text-red-100 text-left ">
                                          {errors.propertyIdentified}
                                        </div>
                                      )}
                                    </div>
                                  ) : null}

                                  {values.productTypeId == '2' ? (
                                    <div className="flex flex-col justify-between mb-4 mt-2 ml-1">
                                      <div className="flex mt-2 ">
                                        <div className="flex mr-4">
                                          <RadioButton
                                            name="property"
                                            value="commercial"
                                            checked={
                                              values.property === 'commercial'
                                            }
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          />
                                          <label
                                            htmlFor="true"
                                            className="mx-4"
                                          >
                                            Commercial Property
                                          </label>
                                        </div>

                                        <div className="flex">
                                          <RadioButton
                                            name="property"
                                            value="residential"
                                            checked={
                                              values.property === 'residential'
                                            }
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                          />
                                          <label
                                            htmlFor="false"
                                            className="ml-4"
                                          >
                                            Residential Property
                                          </label>
                                        </div>
                                      </div>

                                      {touched.ownShop && (
                                        <div className="text-red-100 text-left ">
                                          {errors.ownShop}
                                        </div>
                                      )}
                                    </div>
                                  ) : null}
                                  {values.propertyIdentified == 'true' ||
                                  (values.productTypeId == '2' &&
                                    values.property) ? (
                                    <div className="">
                                      <div className={`${DetailContainer}`}>
                                        {values.property == 'residential' ||
                                        values.productTypeId != '2' ? (
                                          <CommonSelect sort={true}
                                            name="propertyType"
                                            value={values.propertyType}
                                            onChange={e => {
                                              setFieldValue('propertyType', e);
                                            }}
                                            onBlur={() => {
                                              setFieldTouched(
                                                'propertyType',
                                                true,
                                                true
                                              );
                                            }}
                                            options={
                                              values.productTypeId == '2'
                                                ? propertyTypeOptionsForLAP
                                                : propertyTypeOptions
                                            }
                                            dropdownStyle={{
                                              top: '52px',
                                              fontSize: '16px'
                                            }}
                                            stylesContainer={{
                                              height: '52px'
                                            }}
                                            styleText={{
                                              fontSize: '14px',
                                              padding: '0 20px'
                                            }}
                                            error={
                                              touched.propertyType &&
                                              get(
                                                errors,
                                                'propertyType.value',
                                                false
                                              )
                                            }
                                            touched={touched.propertyType}
                                          />
                                        ) : null}

                                        {values?.productTypeId == '1' &&
                                        values.propertyType.value ==
                                          'Independent House' ? (
                                          <div>
                                            <CommonInput
                                              name="noOfUnit"
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              value={values.noOfUnit}
                                              stylesContainer={{
                                                maxWidth: '100%'
                                              }}
                                              legendName="Number of Units in the Building"
                                              error={
                                                touched.noOfUnit &&
                                                errors.noOfUnit
                                              }
                                              errorMsg={errors.noOfUnit}
                                              touched={touched.noOfUnit}
                                            />
                                          </div>
                                        ) : null}

                                        <div>
                                          <CommonPincode
                                            name="pincode"
                                            value={values.pincode}
                                            onChange={e => {
                                              if (
                                                e.target.value.length <= 6 &&
                                                !isNaN(e.target.value)
                                              ) {
                                                setFieldValue(
                                                  'pincodeCity',
                                                  ''
                                                ),
                                                  setFieldValue(
                                                    'pincodeState',
                                                    ''
                                                  );
                                                handleChange(e);
                                              }
                                            }}
                                            stylesContainer={{
                                              maxWidth: '100%'
                                            }}
                                            error={
                                              errors?.pincode &&
                                              touched?.pincode
                                            }
                                            errorMsg={errors?.pincode}
                                            touched={touched?.pincode}
                                            onPinCodeSucessOrFailure={obj => {
                                              const {
                                                err,
                                                data: pincodeData
                                              } = obj;

                                              if (!err && pincodeData) {
                                                setFieldValue(
                                                  'pincodeCity',
                                                  pincodeData.District
                                                ),
                                                  setFieldValue(
                                                    'pincodeState',
                                                    pincodeData.State
                                                  );
                                                getKhataList();
                                              } else {
                                                setFieldError(
                                                  'pincode',
                                                  'Pincode is not valid'
                                                );
                                              }
                                            }}
                                            onBlur={e => {
                                              handleBlur(e);
                                            }}
                                          />
                                          <p className="pt-3 text-green-500 text-xs">
                                            {values.pincodeCity}{' '}
                                            {values.pincodeState}
                                          </p>
                                        </div>

                                        <CommonSelect sort={true}
                                          name="propertyTitle"
                                          value={values.propertyTitle}
                                          onChange={e => {
                                            setFieldValue('propertyTitle', e);
                                          }}
                                          onBlur={() => {
                                            setFieldTouched(
                                              'propertyTitle',
                                              true,
                                              true
                                            );
                                          }}
                                          options={khataListFun()}
                                          dropdownStyle={{
                                            top: '52px',
                                            fontSize: '16px'
                                          }}
                                          stylesContainer={{
                                            height: '52px'
                                          }}
                                          styleText={{
                                            fontSize: '14px',
                                            padding: '0 20px'
                                          }}
                                          error={
                                            touched.propertyTitle &&
                                            get(
                                              errors,
                                              'propertyTitle.value',
                                              false
                                            )
                                          }
                                          touched={touched.propertyTitle}
                                        />

                                        <InputTypeNumber
                                          name="propertyValue"
                                          value={values.propertyValue}
                                          maxLength={15}
                                          minLength={0}
                                          legendName="Property Value"
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          stylesContainer={{
                                            maxWidth: '100%'
                                          }}
                                          inputStyle={
                                            commonInputTypeNumberStyle
                                          }
                                          iconStyle={{ marginTop: '12px' }}
                                          error={
                                            touched.propertyValue &&
                                            errors.propertyValue
                                          }
                                          errorMsg={errors.propertyValue}
                                          touched={touched.propertyValue}
                                          setFieldValue={setFieldValue}
                                          showInText={false}
                                        />
                                      </div>
                                    </div>
                                  ) : null}
                                </React.Fragment>
                              ) : null}
                              <FieldArray
                                name="allCoApplicant"
                                render={arrayHelpers => {
                                  return (
                                    <div>
                                      <div className="text-base  mt-6 md:my-3 font-medium flex items-center">
                                        <div className="mr-6 font-open-sans-bold">
                                          Co-Applicant Details
                                        </div>
                                        <CommonBtn
                                          value="Add Co-Applicant"
                                          passIcon={plusBp}
                                          stylesBtn={{
                                            padding: '8px 15px'
                                          }}
                                          onClick={() => {
                                            if (
                                              values?.allCoApplicant?.length < 3
                                            ) {
                                              arrayHelpers.push({
                                                coApplicantProfessiontype: {
                                                  value: '',
                                                  label: 'Profession type'
                                                },
                                                coApplicantMonthlyIncome: ''
                                              });
                                            }
                                          }}
                                        />
                                      </div>
                                      <div
                                        className={`${coAppicantContainer} md:pb-10`}
                                      >
                                        {values?.allCoApplicant &&
                                        values?.allCoApplicant?.length > 0
                                          ? values.allCoApplicant.map(
                                              (each, index) => {
                                                return (
                                                  <div key={index} className="">
                                                    <div>
                                                      <div className="text-base py-3">
                                                        Co-Applicant {index + 1}
                                                      </div>
                                                      <div
                                                        className={`${eachContainer}`}
                                                      >
                                                        <CommonSelect sort={true}
                                                          name={`allCoApplicant.${index}.coApplicantProfessiontype`}
                                                          value={
                                                            values
                                                              ?.allCoApplicant[
                                                              index
                                                            ]
                                                              ?.coApplicantProfessiontype
                                                          }
                                                          onChange={e => {
                                                            setFieldValue(
                                                              `allCoApplicant.${index}.coApplicantProfessiontype`,
                                                              e
                                                            );
                                                          }}
                                                          onBlur={() => {
                                                            setFieldTouched(
                                                              `allCoApplicant.${index}.coApplicantProfessiontype`,
                                                              true,
                                                              true
                                                            );
                                                          }}
                                                          options={
                                                            professionTypeOptions
                                                          }
                                                          dropdownStyle={{
                                                            top: '52px',
                                                            fontSize: '16px'
                                                          }}
                                                          stylesContainer={{
                                                            height: '52px'
                                                          }}
                                                          styleText={{
                                                            fontSize: '14px',
                                                            padding: '0 20px'
                                                          }}
                                                          error={
                                                            touched
                                                              .allCoApplicant?.[
                                                              index
                                                            ]
                                                              ?.coApplicantProfessiontype &&
                                                            get(
                                                              errors,
                                                              `allCoApplicant.${index}.coApplicantProfessiontype.value`,
                                                              false
                                                            )
                                                          }
                                                          touched={
                                                            touched
                                                              ?.allCoApplicant?.[
                                                              index
                                                            ]
                                                              ?.coApplicantProfessiontype
                                                          }
                                                        />

                                                        <InputTypeNumber
                                                          name={`allCoApplicant[${index}].coApplicantMonthlyIncome`}
                                                          value={
                                                            values
                                                              ?.allCoApplicant[
                                                              index
                                                            ]
                                                              ?.coApplicantMonthlyIncome
                                                          }
                                                          maxLength={15}
                                                          minLength={0}
                                                          legendName="Monthly Income"
                                                          onChange={
                                                            handleChange
                                                          }
                                                          onBlur={handleBlur}
                                                          stylesContainer={{
                                                            maxWidth: '100%'
                                                          }}
                                                          inputStyle={
                                                            commonInputTypeNumberStyle
                                                          }
                                                          iconStyle={{
                                                            marginTop: '12px'
                                                          }}
                                                          error={
                                                            touched
                                                              .allCoApplicant?.[
                                                              index
                                                            ]
                                                              ?.coApplicantMonthlyIncome &&
                                                            errors
                                                              .allCoApplicant?.[
                                                              index
                                                            ]
                                                              ?.coApplicantMonthlyIncome
                                                          }
                                                          touched={
                                                            touched
                                                              ?.allCoApplicant?.[
                                                              index
                                                            ]
                                                              ?.coApplicantMonthlyIncome
                                                          }
                                                          setFieldValue={
                                                            setFieldValue
                                                          }
                                                          showInText={false}
                                                        />
                                                      </div>
                                                      <div
                                                        onClick={() =>
                                                          arrayHelpers.remove(
                                                            index
                                                          )
                                                        }
                                                        className="cursor-pointer hover:font-medium text-red-300 text-right"
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faTrashAlt}
                                                        />
                                                        <span className="mx-2 xmd:mx-4 xxxmd:mx-6 xlg:mx-2">
                                                          Delete
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            )
                                          : null}
                                      </div>
                                    </div>
                                  );
                                }}
                              />
                            </div>

                            <div
                              className={` md:justify-end mt-6 md:fixed  mx-auto w-full justify-center md:w-auto grid gap-3 md:gap-0 md:flex  ${
                                !noteViewType
                                  ? styles?.btnGrp
                                  : styles?.btnGrpNormal
                              }
                              ${
                                leadStatus == 'INTERESTED' ||
                                leadStatus == 'Interested'
                                  ? 'grid-cols-3'
                                  : 'grid-cols-2'
                              } 
                              `}
                            >
                              <CommonBtn
                                classNameStyle="w-full md:w-auto table"
                                buttonContainerClass="w-full md:w-auto"
                                buttonParentClass="w-full md:w-auto"
                                type="submit"
                                value="Save"
                                stylesBtn={{
                                  padding: '8px 20px',
                                  background: '#00ACB8',
                                  color: 'white'
                                }}
                                onClick={() => {
                                  setFieldTouched('gender', true);
                                  if (_.isEmpty(errors)) {
                                    savePDForm();
                                  }
                                }}
                              />
                              <CommonBtn
                                classNameStyle="w-full md:w-auto table"
                                buttonContainerClass="w-full md:w-auto"
                                buttonParentClass="w-full md:w-auto"
                                value="Reject"
                                stylesBtn={{
                                  padding: '8px 20px',
                                  color: '#FD4F60',
                                  border: '1px solid #FD4F60'
                                }}
                                onClick={handleRejection}
                              />
                              {(leadStatus == 'INTERESTED' ||
                                leadStatus == 'Interested') && (
                                <CommonBtn
                                  classNameStyle="w-full md:w-auto table"
                                  buttonContainerClass="w-full md:w-auto"
                                  buttonParentClass="w-full md:w-auto"
                                  type="submit"
                                  value="Accept"
                                  id={'lems_pdApproveBtn'}
                                  stylesBtn={{
                                    padding: '8px 20px',
                                    background: '#28C064',
                                    color: 'white'
                                  }}
                                  onClick={() => {
                                    setFieldTouched('gender', true);
                                    if (_.isEmpty(errors)) {
                                      handleAcception();
                                    }
                                  }}
                                />
                              )}
                            </div>
                          </div>
                          {noteViewType && noteViewType != 'False' && (
                            <div className="table">
                              <div className={`hidden md:block `}>
                                <Drawer
                                  anchor="right"
                                  open={showNotes}
                                  onClose={() => setShowNotes(false)}
                                  onOpen={() => setShowNotes(true)}
                                  classes={{
                                    root: classes.drawerRightRoot,
                                    paper: classes.drawerRightPaaper
                                  }}
                                >
                                  <GetNotesSection />
                                </Drawer>
                              </div>
                              <div className="md:hidden block">
                                <Drawer
                                  anchor="bottom"
                                  open={showNotes}
                                  onClose={() => setShowNotes(false)}
                                  onOpen={() => setShowNotes(true)}
                                  classes={{
                                    root: classes.drawerBottomRoot,
                                    paper: classes.drawerBottomPaper,
                                    paperAnchorBottom: classes.paperAnchorBottom
                                  }}
                                >
                                  <GetNotesSection />
                                </Drawer>
                              </div>
                            </div>
                          )}
                          {!noteViewType && noteViewType != 'False' && (
                            <div className="hidden md:block ">
                              <GetNotesSection normalView={true} />
                            </div>
                          )}
                        </div>
                      </ResizeObserver>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
            {showAuditTrail && (
              <div
                className="h-screen fixed right-0 bottom-0 top-0"
                style={{ zIndex: 10000 }}
              >
                <Audit
                  setShowAuditTrail={setShowAuditTrail}
                  showAuditTrail={showAuditTrail}
                />
              </div>
            )}

            <PopUp type={type} text={text} setShow={setShow} show={show} />
          </React.Fragment>
        );
      }}
    </Formik>
  );
};

export default withErrorHandler(PersonalDiscussionForm);
